// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image[data-v-630d5b06]{height:100%}.image img[data-v-630d5b06]{width:100%}.sidebar[data-v-630d5b06]{flex:0 0 235px;height:200px;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
